import * as THREE from 'three';
window.THREE = THREE;
import App from './App.svelte';
const app = new App({
    target: document.body,
});
export default app;
